import React, { useState } from "react";
import { HABIT_LIBRARY } from "../habitLibrary";

// ─────────────────────────────────────────────
// ZENITH TOKENS
// ─────────────────────────────────────────────
const Z = {
  primary:        "#55624d",
  primaryFixed:   "#d9e7cd",
  primaryFixedDim:"#bdcbb2",
  onPrimary:      "#ffffff",
  surface:        "#f8faf3",
  surfaceContainer: "#ecefe8",
  surfaceContainerLow: "#f2f4ed",
  surfaceContainerLowest: "#ffffff",
  onSurface:      "#191c18",
  onSurfaceVariant: "#444841",
  secondary:      "#755754",
  secondaryContainer: "#fed7d2",
  onSecondaryContainer: "#795b58",
  outline:        "#757870",
  outlineVariant: "#c5c8be",
  error:          "#ba1a1a",
};

export function DiscoverTab({ onAddHabit }) {
  const [selectedCat, setSelectedCat]     = useState(null);
  const [selectedSub, setSelectedSub]     = useState(null);
  const [selectedHabit, setSelectedHabit] = useState(null);
  const [addedIds, setAddedIds]           = useState([]);

  const handleAdd = (habit) => {
    const section = habit.time === "night" ? "night" : "morning";
    onAddHabit(section, habit.label, habit.id);
    setAddedIds((prev) => [...prev, habit.id]);
  };

  const isAdded = (id) => addedIds.includes(id);

  // ── HABIT DETAIL ──────────────────────────
  if (selectedHabit) {
    const added = isAdded(selectedHabit.id);
    return (
      <div style={{ padding: "24px 20px", maxWidth: 480, margin: "0 auto" }}>
        <button onClick={() => setSelectedHabit(null)} style={backBtnStyle}>
          ← {selectedSub.label}
        </button>

        <div style={{ marginTop: 20, marginBottom: 24 }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>{selectedHabit.icon}</div>
          <h2 style={{ fontFamily: "'Manrope', sans-serif", fontSize: 22, fontWeight: 500, color: Z.onSurface, margin: "0 0 12px", lineHeight: 1.3 }}>
            {selectedHabit.label}
          </h2>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <Chip color={Z.primaryFixed} text={Z.primary}>
              {selectedHabit.time === "morning" ? "☀️ Morgen" : selectedHabit.time === "night" ? "🌙 Abend" : "⏰ Flexibel"}
            </Chip>
            <Chip color={Z.secondaryContainer} text={Z.onSecondaryContainer}>
              {selectedCat.icon} {selectedCat.label}
            </Chip>
          </div>
        </div>

        <InfoCard label="Worum geht's?">
          <p style={bodyText}>{selectedHabit.why}</p>
        </InfoCard>

        <InfoCard label="So geht's" style={{ marginTop: 12 }}>
          <p style={bodyText}>{selectedHabit.dose}</p>
        </InfoCard>

        {/* Quellen bleiben ausgeblendet, bis sie einzeln geprüft sind (siehe docs/GESUNDHEITS-AUDIT.md) */}
        <p style={{ ...bodyText, fontSize: 12, color: Z.outline, marginTop: 12 }}>
          Allgemeine Informationen, keine medizinische Beratung. Bei Vorerkrankungen, Schwangerschaft oder Medikamenteneinnahme vorher ärztlich abklären.
        </p>

        <button
          onClick={() => !added && handleAdd(selectedHabit)}
          style={{
            width: "100%", marginTop: 20, padding: "15px",
            borderRadius: 14, border: "none", cursor: added ? "default" : "pointer",
            background: added ? Z.primaryFixed : Z.primary,
            color: added ? Z.primary : Z.onPrimary,
            fontSize: 15, fontWeight: 600,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            letterSpacing: "0.01em",
          }}
        >
          {added ? "✓ Zur Routine hinzugefügt" : `+ Zu meiner ${selectedHabit.time === "night" ? "Abend" : "Morgen"}-Routine`}
        </button>
      </div>
    );
  }

  // ── UNTERKATEGORIEN ───────────────────────
  if (selectedCat) {
    return (
      <div style={{ padding: "24px 20px", maxWidth: 480, margin: "0 auto" }}>
        <button onClick={() => { setSelectedCat(null); setSelectedSub(null); }} style={backBtnStyle}>
          ← Kategorien
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: 14, margin: "20px 0 24px" }}>
          <span style={{ fontSize: 32 }}>{selectedCat.icon}</span>
          <h2 style={{ fontFamily: "'Manrope', sans-serif", fontSize: 22, fontWeight: 500, color: Z.onSurface, margin: 0 }}>
            {selectedCat.label}
          </h2>
        </div>

        {selectedCat.subcategories.map((sub) => (
          <div key={sub.id} style={{ marginBottom: 16 }}>
            <button
              onClick={() => setSelectedSub(selectedSub?.id === sub.id ? null : sub)}
              style={{
                width: "100%", display: "flex", alignItems: "center",
                justifyContent: "space-between", padding: "14px 16px",
                borderRadius: 14,
                border: `1px solid ${selectedSub?.id === sub.id ? Z.primaryFixedDim : Z.outlineVariant}`,
                background: selectedSub?.id === sub.id ? Z.primaryFixed : Z.surfaceContainerLowest,
                cursor: "pointer", fontFamily: "'Plus Jakarta Sans', sans-serif", marginBottom: 8,
                transition: "all 0.15s",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 18 }}>{sub.icon}</span>
                <span style={{ fontSize: 15, fontWeight: 500, color: Z.onSurface }}>{sub.label}</span>
                <span style={{ fontSize: 12, color: Z.outline }}>{sub.habits.length}</span>
              </div>
              <span style={{ color: Z.outline, fontSize: 12 }}>{selectedSub?.id === sub.id ? "▲" : "▼"}</span>
            </button>

            {selectedSub?.id === sub.id && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4 }}>
                {sub.habits.map((habit) => {
                  const added = isAdded(habit.id);
                  return (
                    <div key={habit.id} style={{
                      background: Z.surfaceContainerLowest,
                      border: `1px solid ${Z.outlineVariant}`,
                      borderRadius: 12, padding: "12px 14px",
                      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
                    }}>
                      <button
                        onClick={() => { setSelectedSub(sub); setSelectedHabit(habit); }}
                        style={{ flex: 1, display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer", textAlign: "left", fontFamily: "'Plus Jakarta Sans', sans-serif", padding: 0 }}
                      >
                        <span style={{ fontSize: 20, flexShrink: 0 }}>{habit.icon}</span>
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 500, color: Z.onSurface }}>{habit.label}</div>
                          <div style={{ fontSize: 12, color: Z.outline, marginTop: 2 }}>
                            {habit.time === "morning" ? "☀️ Morgen" : habit.time === "night" ? "🌙 Abend" : "⏰ Flexibel"} · Details ansehen
                          </div>
                        </div>
                      </button>
                      <button
                        onClick={() => !added && handleAdd(habit)}
                        style={{
                          flexShrink: 0, padding: "6px 14px", borderRadius: 20,
                          border: `1px solid ${added ? Z.primaryFixedDim : Z.outlineVariant}`,
                          background: added ? Z.primaryFixed : "transparent",
                          color: added ? Z.primary : Z.onSurfaceVariant,
                          fontSize: 13, fontWeight: 500, cursor: added ? "default" : "pointer",
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                        }}
                      >
                        {added ? "✓" : "+"}
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  // ── KATEGORIEN ÜBERSICHT ──────────────────
  return (
    <div style={{ padding: "24px 20px", maxWidth: 480, margin: "0 auto" }}>
      <h2 style={{ fontFamily: "'Manrope', sans-serif", fontSize: 22, fontWeight: 500, color: Z.onSurface, marginBottom: 6 }}>
        Habit-Bibliothek
      </h2>
      <p style={{ fontSize: 13, color: Z.onSurfaceVariant, marginBottom: 24, lineHeight: 1.6 }}>
        Kuratiert nach Huberman, Attia & aktueller Forschung.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {HABIT_LIBRARY.map((cat) => {
          const total = cat.subcategories.reduce((n, s) => n + s.habits.length, 0);
          return (
            <button
              key={cat.id}
              onClick={() => setSelectedCat(cat)}
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "16px 18px", borderRadius: 16,
                border: `1px solid ${Z.outlineVariant}`,
                background: Z.surfaceContainerLowest,
                cursor: "pointer", fontFamily: "'Plus Jakarta Sans', sans-serif", textAlign: "left",
                transition: "background 0.15s, border-color 0.15s",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: Z.primaryFixed, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
                  {cat.icon}
                </div>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 600, color: Z.onSurface }}>{cat.label}</div>
                  <div style={{ fontSize: 12, color: Z.outline, marginTop: 2 }}>
                    {cat.subcategories.length} Kategorien · {total} Habits
                  </div>
                </div>
              </div>
              <span style={{ color: Z.outline, fontSize: 18 }}>›</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────
function Chip({ color, text, children }) {
  return (
    <span style={{ fontSize: 12, fontWeight: 500, background: color, color: text, borderRadius: 20, padding: "4px 12px", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      {children}
    </span>
  );
}

function InfoCard({ label, children, style }) {
  return (
    <div style={{ background: Z.surfaceContainerLowest, border: `1px solid ${Z.outlineVariant}`, borderRadius: 14, padding: "14px 16px", ...style }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: Z.outline, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 8, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
        {label}
      </div>
      {children}
    </div>
  );
}

const backBtnStyle = {
  background: "none", border: "none", padding: 0,
  fontSize: 14, color: Z.onSurfaceVariant, cursor: "pointer",
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  display: "flex", alignItems: "center", gap: 4,
};

const bodyText = {
  fontSize: 14, color: Z.onSurface, lineHeight: 1.75, margin: 0,
  fontFamily: "'Plus Jakarta Sans', sans-serif",
};
